import { render, staticRenderFns } from "./FactorNav.vue?vue&type=template&id=6fcb2512&scoped=true&"
import script from "./FactorNav.vue?vue&type=script&lang=ts&"
export * from "./FactorNav.vue?vue&type=script&lang=ts&"
import style0 from "./FactorNav.vue?vue&type=style&index=0&id=6fcb2512&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcb2512",
  null
  
)

export default component.exports